import type { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";
import { bffApi } from "../../autogen/bff-api";

const ATTACHMENT_NO_LONGER_ON_NEED = "zz_DocumentApiErrorCode_AttachmentNoLongerOnNeed";
const NEED_ALREADY_STARTED = "zz_FrameworkAgreementApiErrorCodeNeedAlreadyStarted";

const errorCodeOf = (error: unknown): unknown => (error as { data?: { errorCode?: unknown } } | null)?.data?.errorCode;

export const isNeedAlreadyStarted = (error: unknown) => errorCodeOf(error) === NEED_ALREADY_STARTED;

export const reloadNeedIfStale = (error: unknown, dispatch: ThunkDispatch<unknown, unknown, AnyAction>) => {
  const code = errorCodeOf(error);
  if (code === ATTACHMENT_NO_LONGER_ON_NEED || code === NEED_ALREADY_STARTED) {
    dispatch(bffApi.util.invalidateTags(["Need"]));
  }
};
